import { PhoneIcon } from '@heroicons/react/24/outline';
import type { PracticeListItem } from '../../../services/accounts';

// Action items are cancelled as a feature, so this column only ever had one
// real signal - unresolved calls. Renamed from the old "Attention" column
// (which also tracked openItems/overdue) to name that honestly.
interface OpenCallsCellProps {
    practice: PracticeListItem;
}

export function OpenCallsCell({ practice }: OpenCallsCellProps) {
    if (practice.openCalls === 0) {
        return null;
    }
    return (
        <span
            className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 rounded-full h-6 px-1.5 text-[11px] font-semibold whitespace-nowrap"
            title={`${practice.openCalls} unresolved call${practice.openCalls === 1 ? '' : 's'}`}
        >
            <PhoneIcon className="h-3 w-3 text-gray-400" />
            {practice.openCalls}
        </span>
    );
}
